// HomePeople.js
import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Box, styled } from "@mui/material";
import Header from "../componentsPeopletech/Header";
import BarraApp from "../componentsPeopletech/Barraaps"; // Asegúrate de que sea el nombre correcto
import ServicesCircles from "../componentsPeopletech/ServicesCircles";
import Footer from "../componentsPeopletech/Footer/Footer";
import ContactSection from "../componentsPeopletech/ContactSection";

const HomePeople = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'en';
  const baseUrl = 'https://peoplefortech.com'; // Cambiar por tu dominio real

  const BackgroundVideoContainer = styled(Box)({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      zIndex: 1,
    },
  });

  const Video = styled('video')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    minWidth: '100%',
    minHeight: '100%',
    width: 'auto',
    height: 'auto',
    transform: 'translate(-50%, -50%)',
    filter: 'blur(5px)',
    objectFit: 'cover',
    zIndex: 0,
    opacity: 1,
  });

  const ContentWrapper = styled(Box)({
    position: 'relative',
    zIndex: 1,
    backgroundColor: 'transparent',
  });

  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>{t('seo.homeTitle')}</title>
        <meta name="description" content={t('seo.homeDescription')} />
        <meta name="keywords" content={t('seo.homeKeywords')} />
        <link rel="canonical" href={`${baseUrl}/${currentLang === 'en' ? '' : currentLang + '/'}`} />
        <html lang={currentLang} />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/${currentLang === 'en' ? '' : currentLang + '/'}`} />
        <meta property="og:title" content={t('seo.homeTitle')} />
        <meta property="og:description" content={t('seo.homeDescription')} />
        <meta property="og:image" content={`${baseUrl}/og-image.jpg`} />
        <meta property="og:locale" content={currentLang} />
        <meta property="og:locale:alternate" content="en" />
        <meta property="og:locale:alternate" content="es" />
        <meta property="og:locale:alternate" content="pt" />
        <meta property="og:locale:alternate" content="fr" />
        <meta property="og:locale:alternate" content="de" />
        <meta property="og:locale:alternate" content="zh" />
        <meta property="og:locale:alternate" content="ar" />
        <meta property="og:locale:alternate" content="hi" />
        <meta property="og:locale:alternate" content="ru" />
        <meta property="og:locale:alternate" content="ja" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={`${baseUrl}/${currentLang === 'en' ? '' : currentLang + '/'}`} />
        <meta property="twitter:title" content={t('seo.homeTitle')} />
        <meta property="twitter:description" content={t('seo.homeDescription')} />
        <meta property="twitter:image" content={`${baseUrl}/twitter-image.jpg`} />
        
        {/* Hreflang tags para multiidioma */}
        <link rel="alternate" hreflang="en" href={`${baseUrl}/`} />
        <link rel="alternate" hreflang="es" href={`${baseUrl}/es`} />
        <link rel="alternate" hreflang="pt" href={`${baseUrl}/pt`} />
        <link rel="alternate" hreflang="fr" href={`${baseUrl}/fr`} />
        <link rel="alternate" hreflang="de" href={`${baseUrl}/de`} />
        <link rel="alternate" hreflang="zh" href={`${baseUrl}/zh`} />
        <link rel="alternate" hreflang="ar" href={`${baseUrl}/ar`} />
        <link rel="alternate" hreflang="hi" href={`${baseUrl}/hi`} />
        <link rel="alternate" hreflang="ru" href={`${baseUrl}/ru`} />
        <link rel="alternate" hreflang="ja" href={`${baseUrl}/ja`} />
        <link rel="alternate" hreflang="x-default" href={`${baseUrl}/`} />
      </Helmet>
      <BackgroundVideoContainer>
        <Video
          autoPlay
          loop
          muted
          playsInline
          src="/18192389-hd_1920_1080_60fps.mp4"
        >
          Tu navegador no soporta la reproducción de videos.
        </Video>
      </BackgroundVideoContainer>
      <ContentWrapper>
        <BarraApp />
        <Header /> {/* Componente de encabezado */}
        <ServicesCircles /> {/* Sección de servicios con círculos negros */}
        <ContactSection /> {/* Sección de contacto */}
        <Footer />
      </ContentWrapper>
    </>
  );
};

export default HomePeople;
